// extracted by mini-css-extract-plugin
export var container = "about-module--container--GpJlX";
export var aboutWrapper = "about-module--aboutWrapper--elFmv";
export var aboutText = "about-module--aboutText--wOcmn";
export var skillsWrapper = "about-module--skillsWrapper--+0Akk";
export var skillsHeading = "about-module--skillsHeading--8zQPo";
export var techWrapper = "about-module--techWrapper--d-3+p";
export var techCard = "about-module--techCard--TrcAg";
export var techInner = "about-module--techInner--Oq9C9";
export var iconWrapper = "about-module--iconWrapper--orf4v";
export var icon = "about-module--icon--mKD-K";
export var label = "about-module--label--XLHxu";